import { Shipping } from '@owl-nest/api-client/latest.ts'
import { t } from '@owl-nest/localize'

/**
 * Maps country codes to their shipping amount for a given list of shippings
 *
 * @param shippings - List of shipping to map data from
 * @returns A map of country codes and shipping amounts
 */
export function mapCountryToShipping(shippings: Array<Shipping> | undefined): Record<string, number> {
  // TODO: Probably clearer to throw
  if (!shippings) return {}

  return shippings.reduce((accumulator: Record<string, number>, shipping: Shipping): Record<string, number> => {
    const countries = shipping.countries?.reduce(
      (countryAccumulator: Record<string, number>, country: string) => ({
        ...countryAccumulator,
        [country]: shipping.amount,
      }),
      {},
    )
    return { ...accumulator, ...countries }
  }, {})
}

// Formats the given label to be displayed in the countries Select component
export function getShippingOptionLabel(label: string, shipping: number | undefined, currencySymbol: string): string {
  const freeShipping = shipping === 0 || shipping === undefined
  return freeShipping
    ? t('%(label)s (included)', { label })
    : `${label} (+\xa0${t('%(currency)s%(amount)s', { amount: shipping, currency: currencySymbol })})`
}
